import React from 'react';
import styles from './TabPanel.module.scss';
export var TabPanel = function (_a) {
    var activeTabIndex = _a.activeTabIndex, children = _a.children, controlledByTabIndex = _a.controlledByTabIndex;
    return (React.createElement("div", { "aria-labelledby": "tab-".concat(controlledByTabIndex), className: controlledByTabIndex !== activeTabIndex ? styles.hidden : undefined, id: "tab-panel-".concat(controlledByTabIndex), role: "tabpanel", tabIndex: 0 }, children));
};
//# sourceMappingURL=TabPanel.js.map